export default {"src":"/_next/static/media/illustration-interview.6cd878e7.svg","height":176,"width":174,"blurWidth":0,"blurHeight":0};